// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Tk_P","tab":"ProcedureTabs_tab__J4E_4"};